export const themeDark = {
  // 背景颜色
  'background-01': '#2D2D2D', //	色值1		#FFFFFF	#FFFFFFFF	暗黑 #2D2D2D	#2D2D2DFF
  'background-02': '#1E1E1E', //	色值2		#F5F7F9	#F5F7F9FF	#1E1E1E	#1E1E1EFF
  'background-03': '#323233', //	色值3		#FFFFFF	#FFFFFFFF	#323233	#323233FF
  'background-04': 'rgba(255, 255, 255, 0.02)', //	色值4		#FFFFFF	#FFFFFFFF	#FFFFFF  2 %	#FFFFFF05
  // 公用色
  'theme-common-01': 'rgba(73,143,242,0.85)', //	—	normal：	#417FF9	#417FF9FF	#498FF2  85 %	#498FF2D9
  'theme-common-02': 'rgba(73,143,242,0.95)', //	hover：	#608DFA	#608DFAFF	#498FF2  95 %	#498FF2F2
  'theme-common-03': 'rgba(73,143,242,0.6)', //	click：	#1F72F1	#1F72F1FF	#498FF2  60 %	#498FF299
  'theme-common-04': 'rgba(73,143,242,0.4)', //	disable：	#B3CCFD	#B3CCFDFF	#498FF2  40 %	#498FF266
  'theme-common-05': 'rgba(73,143,242,0.15)', //		#ECF2FE	#ECF2FEFF	#498FF2  15 %	#498FF226
  // 组件色
  'theme-wps-01': 'rgba(85,152,242,0.85)', // 文字	normal：	#4991F2	#4991F2FF	#5598F2  85 %	#5598F2D9
  'theme-wps-02': 'rgba(85,152,242,0.95)', // hover：	#699EF4	#699EF4FF	#5598F2  95 %	#5598F2F2
  'theme-wps-03': 'rgba(85,152,242,0.6)', //	click：	#3684E4	#3684E4FF	#5598F2  60 %	#5598F299
  'theme-wps-04': 'rgba(85,152,242,0.4)', //	disable：	#B6D3FA	#B6D3FAFF	#5598F2  40 %	#5598F266
  'theme-wps-05': 'rgba(85,152,242,0.15)', //		#DBE9FC	#DBE9FCFF	#5598F2  15 %	#5598F226
  'theme-et-01': 'rgba(66,179,134,0.85)', // ET	normal：	#1FBB7D	#1FBB7DFF	#42B386  85 %	#42B386D9
  'theme-et-02': 'rgba(66,179,134,0.95)', //	hover：	#22CA87	#22CA87FF	#42B386  95 %	#42B386F2
  'theme-et-03': 'rgba(66,179,134,0.6)', //	click：	#1CAC73	#1CAC73FF	#42B386  60 %	#42B38699
  'theme-et-04': 'rgba(66,179,134,0.4)', //	disable：	#A5E4CB	#A5E4CBFF	#42B386  40 %	#42B38666
  'theme-et-05': 'rgba(66,179,134,0.15)', //		#D2F1E5	#D2F1E5FF	#42B386  15 %	#42B38626
  'theme-wpp-01': 'rgba(230,119,85,0.85)', // WPP	normal：	#F46D43	#F46D43FF	#E67755  85 %	#E67755D9
  'theme-wpp-02': 'rgba(230,119,85,0.95)', //	hover：	#F5846A	#F5846AFF	#E67755  95 %	#E67755F2
  'theme-wpp-03': 'rgba(230,119,85,0.6)', //	click：	#E36134	#E36134FF	#E67755  60 %	#E6775599
  'theme-wpp-04': 'rgba(230,119,85,0.4)', //	disable：	#FBC5B4	#FBC5B4FF	#E67755  40 %	#E6775566
  'theme-wpp-05': 'rgba(230,119,85,0.15)', //		#FDE2D9	#FDE2D9FF	#E67755  15 %	#E6775526
  'theme-pdf-01': 'rgba(230,103,101,0.85)', // pdf	normal：	#EB5451	#EB5451FF	#E66765  85 %	#E67755D9
  'theme-pdf-02': 'rgba(230,103,101,0.95)', //	hover：	#EC6E6C	#EC6E6CFF	#E66765  95 %	#E67755F2
  'theme-pdf-03': 'rgba(230,103,101,0.6)', //	click：	#E13F3B	#E13F3BFF	#E66765  60 %	#E6775599
  'theme-pdf-04': 'rgba(230,103,101,0.4)', //	disable：	#F7BBB9	#F7BBB9FF	#E66765  40 %	#E6775566
  'theme-pdf-05': 'rgba(230,103,101,0.15)', //		#FBDDDC	#FBDDDCFF	#E66765  15 %	#E6775526
  // 功能色
  'error-01': 'rgba(238,84,75,0.85)', // 失败删除	normal：	#EE544B	#EE544BFF	#EE544B  85 %	#EE544BD9
  'error-02': 'rgba(238,84,75,0.95)', //	hover：	#FB685F	#FB685FFF	#EE544B  95 %	#EE544BF2
  'error-03': 'rgba(238,84,75,0.6)', //	click：	#E13C32	#E13C32FF	#EE544B  60 %	#EE544B99
  'error-04': 'rgba(238,84,75,0.4)', //	disable：	#F8BBB7	#F8BBB7FF	#EE544B  40 %	#EE544B66
  'error-05': 'rgb(238,84,75,0.15)', //		#FEECEB	#FEECEBFF	#EE544B  15 %	#EE544B26
  'warning-01': 'rgba(255,170,0,0.85)', // 警示	normal：	#FFAA00	#FFAA00FF	#FFAA00  85 %	#FFAA00D9
  'warning-02': 'rgba(255,170,0,0.95)', //	hover：	#FFBB33	#FFBB33FF	#FFAA00  95 %	#FFAA00F2
  'warning-03': 'rgba(255,170,0,0.6)', //	click：	#E59800	#E59800FF	#FFAA00  60 %	#FFAA0099
  'warning-04': 'rgba(255,170,0,0.4)', //	disable：	#FFDD99	#FFDD99FF	#FFAA00  40 %	#FFAA0066
  'warning-05': 'rgba(255,170,0,0.15)', //		#FFF6E5	#FFF6E5FF	#FFAA00  15 %	#FFAA0026
  'success-01': 'rgba(77,191,96,0.85)', // 成功	normal：	#3FC857	#3FC857FF	#4DBF60  85 %	#4DBF60D9
  'success-02': 'rgba(77,191,96,0.95)', //	hover：	#52DD6A	#52DD6AFF	#4DBF60  95 %	#4DBF60F2
  'success-03': 'rgba(77,191,96,0.6)', //	click：	#32A846	#32A846FF	#4DBF60  60 %	#4DBF6099
  'success-04': 'rgba(77,191,96,0.4)', //	disable：	#B2E9BC	#B2E9BCFF	#4DBF60  40 %	#4DBF6066
  'success-05': 'rgba(77,191,96,0.15)', //		#ECF9EE	#ECF9EEFF	#4DBF60  15 %	#4DBF6026
  // 状态色
  'status-01': 'rgba(255,255,255,0)', // —	normal：	#C6CED6  0 %	#C6CED600	#FFFFFF  0 %	#FFFFFF00
  'status-02': 'rgba(255,255,255,0.06)', //	hover：	#C6CED6  20 %	#C6CED633	#FFFFFF  6 %	#FFFFFF0F
  'status-03': 'rgba(255,255,255,0.1)', //	click：	#C6CED6  40 %	#C6CED666	#FFFFFF  10 %	#FFFFFF1A
  'status-04': 'rgba(255,255,255,0.08)', //	foucs：	#C6CED6  30 %	#C6CED666	#FFFFFF  8 %	#FFFFFF14
  'status-001': 'rgba(255,255,255,0)', // 组件	normal：	#C6CED6  0 %	#C6CED600	#FFFFFF  0 %	#FFFFFF00
  'status-002': 'rgba(255,255,255,0.1)', // hover：	#C6CED6  40 %	#C6CED666	#FFFFFF  10 %	#FFFFFF1A
  'status-003': 'rgba(255, 255, 255, 0.14)', // click：	#C6CED6  60 %	#C6CED699	#FFFFFF  14 %	#FFFFFF24
  'status-004': 'rgba(255,255,255,0.12)', // foucs：	#C6CED6  50 %	#C6CED699	#FFFFFF  12 %	#FFFFFF1F
  // 文字
  'text-01': 'rgba(255,255,255,0.95)', // 色值1		#0C0F17	#0C0F17FF	#FFFFFF  95 %	#FFFFFFF2
  'text-02': 'rgba(255,255,255,0.85)', // 色值2		#262E3E	#262E3EFF	#FFFFFF  85 %	#FFFFFFD9
  'text-03': 'rgba(255,255,255,0.6)', // 色值3		#444E63	#444E63FF	#FFFFFF  60 %	#FFFFFF99
  'text-04': 'rgba(255,255,255,0.4)', // 色值4		#727E96	#727E96FF	#FFFFFF  40 %	#FFFFFF66
  'text-05': 'rgba(255,255,255,0.3)', // 色值5		#8B95A8	#8B95A8FF	#FFFFFF  30 %	#FFFFFF4D
  'text-06': 'rgba(255,255,255,0.15)', // 色值6		#A2AABA	#A2AABAFF	#FFFFFF  15 %	#FFFFFF26
  'texts-01': 'rgba(255,255,255,0.5)', // 色值1		#262E3E	#262E3EFF	#FFFFFF  50 %	#FFFFFF80
  'texts-02': 'rgba(255,255,255,0.4)', // 色值2		#444E63	#444E63FF	#FFFFFF  40 %	#FFFFFF66
  'texts-03': 'rgba(255,255,255,0.8)', // 色值3		#FFFFFF	#FFFFFFFF	#FFFFFF  80 %	#FFFFFFCC
  'texts-04': 'rgba(255,255,255,0.3)', // 色值4		#FFFFFF	#FFFFFFFF	#FFFFFF  30 %	#FFFFFF4D
  // 图标
  'icon-01': 'rgba(255,255,255,0.95)', // 色值1		#0C0F17	#0C0F17FF	#FFFFFF  95 %	#FFFFFFF2
  'icon-02': 'rgba(255,255,255,0.85)', // 色值2		#262E3E	#262E3EFF	#FFFFFF  85 %	#FFFFFFD9
  'icon-03': 'rgba(255,255,255,0.6)', // 色值3		#444E63	#444E63FF	#FFFFFF  60 %	#FFFFFF99
  'icon-04': 'rgba(255,255,255,0.4)', // 色值4		#727E96	#727E96FF	#FFFFFF  40 %	#FFFFFF66
  'icon-05': 'rgba(255,255,255,0.3)', // 色值5		#8B95A8	#8B95A8FF	#FFFFFF  30 %	#FFFFFF4D
  'icon-06': 'rgba(255,255,255,0.15)', // 色值6		#A2AABA	#A2AABAFF	#FFFFFF  15 %	#FFFFFF26
  'icons-01': 'rgba(255,255,255,0.5)', // 色值1		#262E3E	#36425AFF	#FFFFFF  50 %	#FFFFFF80
  'icons-02': 'rgba(255,255,255,0.4)', // 色值2		#444E63	#4F5D79FF	#FFFFFF  40 %	#FFFFFF66
  'icons-03': 'rgba(255,255,255,0.8)', // 色值3		#FFFFFF	#FFFFFFFF	#FFFFFF  80 %	#FFFFFFCC
  'icons-04': 'rgba(255,255,255,0.3)', // 色值4		#FFFFFF	#FFFFFFFF	#FFFFFF  30 %	#FFFFFF4D
  'icons-05': 'rgba(255,255,255,0.2)', // 色值5		#262E3E  12 %	#262E3E1F	#FFFFFF  20 %	#FFFFFF33
  // 分割线
  'separator-01': 'rgba(24,24,24,0.5)', // 色值1		#F3F4F5	#F3F4F5FF	#181818  50 %	#18181880
  'separator-02': 'rgba(255,255,255,0.1)', // 色值2		#E4E6EB	#E4E6EBFF	#FFFFFF  10 %	#FFFFFF1A
  'separator-03': 'rgba(255,255,255,0.2)', // 色值3		#D7D9DE	#D7D9DEFF	#FFFFFF  20 %	#FFFFFF33
  'separator-04': 'rgba(255,255,255,0.1)', // 色值4		#F3F4F5	#F3F4F5FF	#FFFFFF  10 %	#FFFFFF1A
  // 滚动条
  'scroll-01': 'rgba(230,238,255,0.1)', // 色值1	normal：	#262E3E  10 %	#262E3E1A	#E6EEFF  10 %	#E6EEFF1A
  'scroll-02': 'rgba(230,238,255,0.2)', // 色值2	hover：	#262E3E  20 %	#262E3E33	#E6EEFF  20 %	#E6EEFF33
  'scroll-03': 'rgba(230,238,255,0.3)', // 色值3	click：	#262E3E 30 %	#262E3E4D	#E6EEFF  30 %	#E6EEFF4D
  // 控件
  'ctl-border-01': 'rgba(255,255,255,0.2)', // 边框	normal：	#D7D9DE	#D7D9DEFF	#FFFFFF  20 %	#FFFFFF33
  'ctl-border-02': 'rgba(255,255,255,0.35)', //	hover：	#B9BDC6	#B9BDC6FF	#FFFFFF  35 %	#FFFFFF59
  'ctl-border-03': 'rgba(255,255,255,0.4)', //	click：	#AFB3BD	#AFB3BDFF	#FFFFFF  40 %	#FFFFFF66
  'ctl-border-04': 'rgba(255,255,255,0.1)', //	disable：	#ECECEC	#ECECECFF	#FFFFFF  10 %	#FFFFFF1A
  'ctl-background-01': 'rgba(24,24,24,0.2)', // 填充	normal：	#FFFFFF	#FFFFFFFF	#181818  20 %	#18181833
  'ctl-background-02': 'rgba(30,30,30,0.4)', //	hover：	#EDF0F2	#EDF0F2FF	#1E1E1E  40 %	#1E1E1E66
  'ctl-background-03': 'rgba(24,24,24,0.4)', //	click：	#E8EBEF	#E8EBEFFF	#181818  40 %	#18181866
  'ctl-background-04': 'rgba(24,24,24,0.04)', //	disable：	#FFFFFF	#FFFFFFF	#181818  4 %	#1818180A
  // 弹窗
  'dlg-border-01': 'rgba(255,255,255,0.3)', // 描边		#262E3E  15 %	#262E3E26	#FFFFFF  30 %	#FFFFFF4D
  'dlg-background-01': '#323233', // 背景		#FFFFFF	#FFFFFFFF	#323233	#323233FF
  'dlg-background-02': '#1E1E1E', //		#F5F7F9	#F5F7F9FF	#1E1E1E	#1E1E1EFF
  // 骨架图
  'loading-01': 'rgba(255,255,255,0.06)', // —		#C6CED6  20 %	#C6CED633	#FFFFFF  6 %	#FFFFFF0F
  // toast
  'toast-01': 'rgba(84,84,84,0.9)', // —		#000000 60 %	#00000099	#545454  90 %	#545454E6
  'toast-02': 'rgba(0,0,0,0.8)', // —		#000000 60 %	#00000099	#000000  80 %	#000000CC
  // 透明填充色
  'fill-01': 'rgba(0,0,0,0)', // —		#000000 0 %	#00000000	#000000  0 %	#00000000
  // 自定义颜色
  'custom-text-01': 'rgba(255, 255, 255, 0.85)', // "#36425a"
  'custom-text-02': 'rgba(255, 255, 255, 0.6)', // "#4f5d79",
  'custom-text-03': 'rgba(255, 255, 255, 0.4)', // "#8b97af",
  'custom-text-09': 'rgba(255, 255, 255, 0.6)', //
  'custom-text-10': 'rgba(255, 255, 255, 0.85)', //
  'custom-text-12': '#ff0000', //
  'custom-text-13': 'rgba(255, 255, 255, 0.3)', //
  'custom-text-15': 'rgba(26, 20, 12, 0.85)', //
  'custom-text-17': '#000',
  'custom-text-18': 'rgba(73, 143, 242, 0.6)', //
  'custom-text-19': '#6D7582', //
  'custom-text-20': 'rgba(255, 255, 255, 0.85)', //
  'custom-border-color-01': 'rgba(255, 255, 255, 0.3)', // "rgba(54,66,90,0.15)",
  'custom-border-color-02': 'rgba(24, 24, 24, 0.5)', // "rgba(215,217,222,1)",
  'custom-border-05': 'rgba(24, 24, 24, 0.1)', //
  'custom-border-06': 'rgba(255, 255, 255, 0.35)', //
  'custom-border-07': 'rgba(255, 255, 255, 0.1)', //
  'custom-border-09': 'rgba(255, 255, 255, 0.3)', //
  'custom-border-11': 'rgba(0, 0, 0, 0.4)',
  'custom-border-12': 'rgba(255, 255, 255, 0.2)',
  'custom-border-13': 'rgba(0, 0, 0, 0.6)',
  'custom-border-14': 'rgba(255, 255, 255, 0.3)',
  'custom-box-bold-shadow': '0px 4px 8px 0px rgba(0,0,0,0.3)', // "0px4px8px0pxrgba(0,0,0,0.3)",
  'custom-bg-hover-secondary': 'rgba(255, 255, 255, 0.1)', // "rgba(25,55,88,0.04)",
  'custom-bg-click': 'rgba(255, 255, 255, 0.06)', //
  bg: 'rgba(39, 40, 41)', // "rgba(198,206,214,0)",
  'custom-bg-white': 'rgb(30, 30, 30)', //
  'custom-bg-03': '#f1f1f1', // 新建页
  'custom-bg-04': 'rgba(230, 238, 255, 0.1)',
  'custom-bg-07': '#f5f7f9', // 分享落地页
  'custom-bg-08': 'rgba(0, 0, 0, 0.3)', // 支付组件
  'custom-bg-10': '#ECF2FE', // 新建页
  'custom-bg-12': 'rgba(84, 84, 84, 0.9)', //
  'custom-bg-13': 'rgba(255, 255, 255, 0.5)',
  'custom-bg-14': 'rgba(255, 255, 255, 0.6)',
  'custom-bg-15': 'rgba(255, 255, 255, 0.4)',
  'custom-bg-20': '#1E1E1E', //
  'custom-bg-21': '#e4e6eb', // 分享落地页
  'custom-bg-22': 'rgba(255, 200, 124, 0.85)', //
  'custom-bg-23': 'rgba(255, 200, 124, 0.6)', //
  'custom-bg-24': 'rgba(255, 200, 124, 0.95)', //
  'custom-bg-25': '#2D2D2D', //
  'custom-bg-26': '#FFFFFF',
  'custom-bg-27': 'rgba(255, 255, 255, 0.1)',
  'custom-bg-28': 'rgba(255, 255, 255, 0.08)',
  'custom-bg-29': 'linear-gradient(90deg, rgba(45, 45, 45, 0.5) 0%, #2D2D2D 100%)',
  'custom-bg-30': 'rgba(255, 255, 255, 0.06)',
  'custom-bg-31': 'rgba(255, 255, 255, 0.1)',
  'custom-icon-01': 'rgba(255, 255, 255,0.6)',
  'custom-icon-02': 'rgba(255, 255, 255,0.4)',
  'custom-icon-03': 'rgba(255, 255, 255,0.3)',
  'custom-mask-bg-01': 'rgba(30, 30, 30, 0.4)', //
  'custom-mask-bg-02': 'rgba(24, 24, 24, 0.4)', //
  'custom-mask-bg-03': 'rgba(24, 24, 24, 0.04)', //
  'custom-mask-bg-04': 'rgba(0, 0, 0, 0.5)', //
  'custom-mask-bg-03-hover': 'rgba(30, 30, 30, 0.4)', //
  'custom-mask-bg-03-click': 'rgba(24, 24, 24, 0.4)', //
  'custom-btn-text-02': '#2460f4', //
  'custom-btn-close-normal': 'rgb(144, 144, 144)', //
  'custom-btn-close-hover': 'rgb(238, 92, 83)', //
  'custom-btn-close-click': 'rgb(241, 149, 144)', //
  // 开关switch
  'custom-switch-inactive': '#848484',
  // 加载动画
  'custom-circle-track': 'rgba(255, 255, 255, 0.2)',
  // 顶部边框颜色
  'custom-top-wrapper-border': 'rgba(255, 255, 255, 0.1)',
  'custom-bg-100': 'transparent',
  'custom-bg-101': 'transparent',
  'custom-bg-102': 'transparent',
  'custom-bg-103': 'rgba(255,255,255,0.1)',
  'custom-bg-104': 'rgba(198, 206, 214, 0.14)',
  'custom-bg-105': 'linear-gradient(180deg, #282828 0%, #1E1E1E 100%)',
};
